export default __webpack_public_path__ + "c37c82310d4ba730e0342f144400dff4.png";